import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Input } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { useCreateCanonicalOpportunity } from '../hooks/useCanonicalOpportunities';
/** "New Opportunity" action: creates a canonical Opportunity from a title, no Notice. */ export function NewOpportunityForm() {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const create = useCreateCanonicalOpportunity();
    const submit = ()=>{
        const trimmed = title.trim();
        if (!trimmed) return;
        create.mutate(trimmed, {
            onSuccess: ()=>{
                toast.success(`Created opportunity "${trimmed}"`);
                setTitle('');
                setOpen(false);
            },
            onError: ()=>toast.error('Could not create opportunity')
        });
    };
    if (!open) {
        return /*#__PURE__*/ _jsxs(Button, {
            size: "sm",
            variant: "outline",
            onClick: ()=>setOpen(true),
            "data-testid": Testids.canonicalOpportunity.newButton,
            children: [
                /*#__PURE__*/ _jsx(Plus, {
                    className: "h-4 w-4 mr-1"
                }),
                "New Opportunity"
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("form", {
        className: "flex items-center gap-2",
        onSubmit: (e)=>{
            e.preventDefault();
            submit();
        },
        children: [
            /*#__PURE__*/ _jsx(Input, {
                autoFocus: true,
                value: title,
                onChange: (e)=>setTitle(e.target.value),
                placeholder: "Opportunity title",
                "aria-label": "Opportunity title",
                "data-testid": Testids.canonicalOpportunity.newTitleInput
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                size: "sm",
                disabled: !title.trim() || create.isPending,
                "data-testid": Testids.canonicalOpportunity.createSubmit,
                children: "Create"
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "button",
                size: "sm",
                variant: "ghost",
                onClick: ()=>setOpen(false),
                children: "Cancel"
            })
        ]
    });
}
